import React from 'react';
import { Navigate } from 'react-router-dom';

const Redirect = function () {
  return <Navigate to="/invalid/redirectpage" replace />;
};

export default Redirect;
